import React, { useState } from 'react';

const Header = () => {
    const [copyText, setCopyText] = useState('Copy');

    const handleCopy = () => {
        const textToCopy = '[phbls-slider]';

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    setCopyText('Copied!');
                    setTimeout(() => setCopyText('Copy'), 2000);
                })
                .catch(err => {
                    console.error('Failed to copy text: ', err);
                });
        } else {
            const textarea = document.createElement('textarea');
            textarea.value = textToCopy;
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                setCopyText('Copied!');
                setTimeout(() => setCopyText('Copy'), 2000);
            } catch (err) {
                console.error('Fallback: Failed to copy text: ', err);
            }
            document.body.removeChild(textarea);
        }
    };

    return (
        <div className='header_area'>
            <div className="shortCode">
                <div className="content">
                    <div className='left'>[phbls-slider]</div>
                    <div className='right' onClick={handleCopy}>{copyText}</div>
                </div>
            </div>
        </div>
    );
};

export default Header;
